/*
 * Sticky "Add to cart" bar (snippets/product-sticky-atc.liquid).
 * - Shows once the product form's Add to cart button has scrolled out of view (above the screen).
 * - Its size picker clicks the matching option buttons in the product form, so the theme updates
 *   the variant, price, stock and URL as usual; the bar mirrors the form's price and variant back.
 * - Its button presses the form's own Add to cart (embroidery checks, cart drawer and errors
 *   behave exactly as with the main button).
 * Re-initialises after a colour switch (assets/colour-switch.js swaps the product section).
 */
(function () {
  'use strict';

  if (window.productStickyAtcLoaded) return;
  window.productStickyAtcLoaded = true;

  var onScroll = null;

  function init() {
    // The bar is rendered inside the product section (so a colour switch brings the new colour's
    // bar), then moved to the end of the page: parts of the product column would otherwise keep
    // "position: fixed" from sticking to the bottom of the screen.
    var bar = document.querySelector('#MainContent [data-sticky-atc]');
    if (!bar) return;
    Array.prototype.forEach.call(document.querySelectorAll('body > [data-sticky-atc]'), function (old) {
      old.remove();
    });
    document.body.appendChild(bar);
    bar.setAttribute('data-sticky-atc-ready', '');

    var form = document.getElementById(bar.getAttribute('data-form-id'));
    var mainButton = form && form.querySelector('[data-add-to-cart]');
    if (!form || !mainButton) return;

    var select = bar.querySelector('[data-sticky-atc-select]');
    var price = bar.querySelector('[data-sticky-atc-price]');
    var button = bar.querySelector('[data-sticky-atc-button]');
    var wrapper = form.closest('[data-product]') || document;

    function syncFromForm() {
      var priceSource = wrapper.querySelector('[data-price-wrapper] [data-product-price]');
      if (price && priceSource) price.textContent = priceSource.textContent.trim();
      var idInput = form.querySelector('[name="id"]');
      if (select && idInput && select.value !== idInput.value) select.value = idInput.value;
      var soldOut = mainButton.hasAttribute('disabled') && !mainButton.classList.contains('is-loading');
      button.disabled = soldOut;
      button.textContent = mainButton.querySelector('[data-add-to-cart-text]')
        ? mainButton.querySelector('[data-add-to-cart-text]').textContent.trim()
        : button.textContent;
    }

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bar.querySelectorAll('select, button').forEach(function (control) {
        control.tabIndex = visible ? 0 : -1;
      });
      document.documentElement.classList.toggle('has-sticky-atc', visible);
    }

    // Visible once the main button has scrolled up under the sticky site header (not before reaching it).
    var header = document.querySelector('[data-site-header], .site-header, header');
    var ticking = false;
    function check() {
      ticking = false;
      if (!document.body.contains(mainButton)) return;
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      setVisible(mainButton.getBoundingClientRect().bottom < Math.max(headerBottom, 0));
    }
    if (onScroll) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
    onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.setTimeout(check, 50);
    };
    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onScroll, {passive: true});
    check();

    if (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var values = [];
        try {
          values = JSON.parse(option.getAttribute('data-options')) || [];
        } catch (e) {
          values = [];
        }
        values.forEach(function (value, index) {
          var radios = form.querySelectorAll('[data-single-option-selector][data-index="option' + (index + 1) + '"]');
          Array.prototype.forEach.call(radios, function (radio) {
            if (radio.value === value && !radio.checked) radio.click();
          });
        });
        window.setTimeout(syncFromForm, 150);
      });
    }

    button.addEventListener('click', function () {
      if (button.disabled) return;
      mainButton.click();
    });

    wrapper.addEventListener('theme:variant:change', function () {
      window.setTimeout(syncFromForm, 50);
    });
    syncFromForm();
  }

  function reset() {
    document.documentElement.classList.remove('has-sticky-atc');
    init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('joiia:colour:switched', reset);
  document.addEventListener('shopify:section:load', reset);
})();
